import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { PhotoModerationDecisionBody } from '@upme/contracts';
import { api } from '../../app/api-client';
import { photoModerationKey } from './queries';

/** Решение модератора по фото: APPROVE / HIDE (+ комментарий-причина). */
export function useDecidePhotoModeration() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ userId, body }: { userId: string; body: PhotoModerationDecisionBody }) =>
      api.patch(`admin/photo-moderation/${userId}`, { json: body }).json(),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: photoModerationKey });
    },
  });
}
